import { MouseStalker } from "../classes/_MouseStalker";

export const setupContents = (): void => {
  const m = new MouseStalker("#contentsCursor");

  m.activateBy("#contentsSlider");

  // eslint-disable-next-line no-new
  new Swiper("#contentsSlider", {
    slidesPerView: 1,
    on: {
      touchMove(_, event) {
        if ("pageX" in event) {
          m.update(event.pageX, event.pageY);
        }
      }
    }
  });
};
